<template>
  <Header/>
  <Slider/>
  <div class="main_m">
    <!--内容-->
    <div class="Article_content">
      <div class="main_text">
        <h1></h1>
      </div>
      <div style="clear: both;"></div>
      <div class="Article_text">{{ detail.post_title }}</div>
      <div class="info">
        <span> 发布时间：{{ detail.post_date }}</span>
      </div>
      <div class="detail" v-html="detail.post_content"/>
      <div style="clear: both"></div>
      <div class="main_next">
        <span v-if="left" class="prevrecord">
          上一条：
             <a :href="'/#/detail?id=' + left.ID">
              {{ left.post_title }}
            </a>
        </span>
        <span v-if="right" class="prevrecord">
          下一条：
          <a :href="'/#/detail?id=' + right.ID">
              {{ right.post_title }}
            </a>
        </span>
      </div>
      <div style="clear: both"></div>

    </div>
    <div style="clear: both"></div>
  </div>
  <Footer/>
</template>

<script>
import Header from "@/components/Header"
import Slider from "@/components/Slider"
import Footer from "@/components/Footer"
import http from "@/util/http"

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Detail",
  components: {Footer, Slider, Header},
  data() {
    return {
      right: undefined,
      left: undefined,
      detail: {},
      related: []
    }
  },
  mounted() {
    this._getDetail()
    this._getRelated()
  },
  methods: {
    _getDetail() {
      http.get('articleDetail', {
        id: this.$route.query.id
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.detail = res.data.data
              // this._domTitle()
            }
          })
    },
    _getRelated() {
      http.get('relatedArticle', {
        id: this.$route.query.id
      })
          .then((res) => {
            if (res.data.status === 0) {
              this.related = res.data.data.related
              this.right = res.data.data.right.length > 0 ? res.data.data.right[0] : undefined
              this.left = res.data.data.left.length > 0 ? res.data.data.left[0] : undefined
            }
          })
    }
  }
}
</script>

<style scoped>
h1 {
  font-weight: bold;
}
a {
  font-weight: bold;
}

</style>